<template>
  <div class="statistics">
    <el-row  class="line ">
      <el-select :disabled = 'loading' v-model="eCharttime"  style="margin-left:5px;" @change="getEchart">
          <el-option  value='1' label="最近30天"></el-option>
          <el-option  value='2' label="最近1年"></el-option>
      </el-select>
    </el-row>
    <el-row style="margin-top:10px;">   
      <div class="echart1">
        <div id="myChart1" :style="{width: '100%', height: '250px'}" ></div>
      <div id="myChart2" :style="{width: '100%', height: '250px'}" ></div>
      </div>
      <div class="echart2">
        <div id="myChart3" :style="{width: '100%', height: '500px'}" ></div>
      </div>
    </el-row>
    <el-row class="line" style="margin-bottom:10px;">
      <div class="search_group">
          <el-radio-group v-model="searchTimebtn" @change = "getTime(searchTimebtn)" >
              <el-radio-button v-for='item in registrationTime_arr' :key='item.id' :label='item.Value'>{{item.Text}}</el-radio-button>
              <el-radio-button label='4'  class="nav-time">
                  <el-date-picker  v-model="customTime"  type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                      value-format="yyyy-MM-dd" @change="changeTime">
                  </el-date-picker>
              </el-radio-button>
          </el-radio-group>
      </div>
    </el-row>
    <el-row class="registrationList" style="margin-bottom:10px;">
          <el-table v-if='statistics' :data="statistics.hospitals" key="statistics.hospitals" style="width: 100%" empty-text="暂无信息" stripe  v-loading="loading" size='mini'>
              <el-table-column  prop="hospitalName"  label="医院" :show-overflow-tooltip = "true"></el-table-column>
              <el-table-column prop="departName" label="科室" ></el-table-column>
              <el-table-column prop="unWrittenCount" label="待诊断" ></el-table-column>
              <el-table-column prop="writingCount" label="诊断中" ></el-table-column>
              <el-table-column prop="unApprovedCount" label="待审核" ></el-table-column>
              <el-table-column prop="approvingCount" label="审核中" ></el-table-column>
              <el-table-column prop="approvedCount" label="已审核" ></el-table-column>
              <el-table-column prop="avgSubmitMins" label="平均诊断耗时(分钟)" ></el-table-column>
              <el-table-column prop="exminedCount" label="待检查" ></el-table-column>
              <el-table-column prop="count" label="检查数" ></el-table-column>
          </el-table>
          <div v-else style="width:100%;height: calc(100vh - 330px);text-align:center;background:#f8f8f8;"  v-loading = 'loading'>
            <img src="../../assets/empty_01.png" alt="" style="width: auto;height: calc(100vh - 357px);"/>
          </div>                       
    </el-row> 
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { formatDate } from '@/utils/index.js'
export default {
  name: 'statistics',
  data() {
    return {
      loading: false,
      searchTimebtn: '最近7天',
      eCharttime: '1',
      customTime: [
        formatDate(new Date(new Date() - 3600 * 1000 * 24 * 7), 'yyyy-MM-dd'),
        formatDate(new Date(), 'yyyy-MM-dd')],
      registrationTime_arr: [
        {
          id: 'absa465132416511234',
          Value: '今天',
          Text: '今天'
        }, {
          id: 'absa465132416513',
          Value: '最近3天',
          Text: '最近3天'
        }, {
          id: 'absa465132416514',
          Value: '最近7天',
          Text: '最近7天'
        }],
      myChart: null,
      option: []
    }
  },
  components: {
  },
  computed: {
    ...mapGetters(['departId', 'statistics', 'checkList', 'proceduresStatistic', 'AvgMinsStatistic', 'hosPitalPercentage'])
  },
  mounted() {
    this.getStatistics()
    // 初始化图表
    this.myChart = {
      myChart1: this.$echarts.init(document.getElementById('myChart1')), // 柱状
      myChart2: this.$echarts.init(document.getElementById('myChart2')), // 折线
      myChart3: this.$echarts.init(document.getElementById('myChart3'))// 饼
    }
    this.getEchart()
  },
  methods: {
    // 获取图表数据
    getEchart() {
      Object.keys(this.myChart).forEach((key, index) => {
        this.myChart[key].showLoading()
      })
      // 图标数据请求
      var tempTime = null
      if (this.eCharttime === '2') {
        tempTime = formatDate(new Date(new Date() - 3600 * 1000 * 24 * 365), 'yyyy-MM-dd')
      } else {
        tempTime = formatDate(new Date(new Date() - 3600 * 1000 * 24 * 29), 'yyyy-MM-dd')
      }
      const req1 = this.$store.dispatch('GetProceduresStatisticsByDate', { dateType: this.eCharttime })
      const req2 = this.$store.dispatch('GetAvgMinsStatisticsByDate', { dateType: this.eCharttime })
      const req3 = this.$store.dispatch('GethosPitalPercentage', { startDate: tempTime, endDate: formatDate(new Date(), 'yyyy-MM-dd') })
      // 发送请求
      Promise.all([req1, req2, req3]).then((result) => {
        this.drawLine()
      }).catch(() => {
        this.drawLine()
      })
    },
    // 画图
    drawLine() {
      // 柱状
      this.option[0] = {
        backgroundColor: '#FFF',
        title: {
          text: '平台诊断状态数据',
          subtext: '单位:个',
          top: '5'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['检查数', '阳性数'],
          y: '10',
          textStyle: {
            fontSize: 14
          }
        },
        grid: {
          left: '3%',
          right: '5.5%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          data: this.proceduresStatistic.dates.map((data) => {
            return data.date
          })
        },
        yAxis: {},
        series: [{
          name: '检查数',
          type: 'bar',
          data: this.proceduresStatistic.dates.map((data) => {
            return data.count
          }),
          itemStyle: {
            normal: {
              color: '#5AB1AF'
            }
          },
          markLine: {
            data: [
              { type: 'average', name: '平均值' }
            ]
          }
        },
        {
          name: '阳性数',
          type: 'bar',
          data: this.proceduresStatistic.dates.map((data) => {
            return data.isPositiveCount
          }),
          itemStyle: {
            normal: {
              color: '#b6a2de'
            }
          },
          markLine: {
            data: [
              { type: 'average', name: '平均值' }
            ]
          }
        }]
      }
      // 折线
      this.option[1] = {
        backgroundColor: '#FFF',
        title: {
          text: '平台诊断耗时数据',
          subtext: '单位:分钟',
          top: '5'
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: '3%',
          right: '5.5%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          data: this.AvgMinsStatistic.dates.map((data) => {
            return data.date
          })
        },
        legend: {
          data: ['平均耗时'],
          y: '10',
          textStyle: {
            fontSize: 14
          }
        },
        yAxis: {},
        series: [{
          name: '平均耗时',
          type: 'line',
          data: this.AvgMinsStatistic.dates.map((data) => {
            return data.avgMins
          }),
          itemStyle: {
            normal: {
              color: '#397ee3',
              width: '3'
            }
          },
          markLine: {
            data: [
              { type: 'average', name: '平均值', color: '#B6A2DE' }
            ]
          }
        }]
      }
      // 饼
      this.option[2] = {
        title: {
          text: '各医院发起占比',
          top: '5'
        },
        backgroundColor: '#fff',
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          x: 'right',
          y: '10',
          data: this.hosPitalPercentage.pieHospitals.map((data) => {
            return data.hospitalName
          })
        },
        calculable: true,
        series: [
          {
            name: '发起占比数',
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            data: this.hosPitalPercentage.pieHospitals.map((data) => {
              return { value: data.count, name: data.hospitalName }
            })
          }
        ]
      }
      Object.keys(this.myChart).forEach((key, index) => {
        this.myChart[key].clear()
        this.myChart[key].setOption(this.option[index])
        this.myChart[key].hideLoading()
      })
    },
    // 获取列表
    getStatistics() {
      this.loading = true
      this.$store.dispatch('GetStatistics', { startDate: this.customTime[0], endDate: this.customTime[1] }
      ).then(() => {
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    changeTime() {
      this.searchTimebtn = '4'
      this.getStatistics()
    },
    getTime(value) {
      switch (value) {
        case '今天':
          this.customTime = [formatDate(new Date(), 'yyyy-MM-dd'), formatDate(new Date(), 'yyyy-MM-dd')]
          break
        case '最近3天':
          this.customTime = [formatDate(new Date(new Date() - 3600 * 1000 * 24 * 3), 'yyyy-MM-dd'), formatDate(new Date(), 'yyyy-MM-dd')]
          break
        case '最近7天':
          this.customTime = [formatDate(new Date(new Date() - 3600 * 1000 * 24 * 7), 'yyyy-MM-dd'), formatDate(new Date(), 'yyyy-MM-dd')]
          break
      }
      this.getStatistics()
    },
    // 条数
    handleSizeChange(val) {
      this.pageSize = val
      this.getStatistics()
    },
    // 分页
    handleCurrentChange(val) {
      this.currentPage = val
      this.getStatistics()
    }
  }
}
</script>
<style  rel="stylesheet/scss"  lang="scss" >
$background-color :  #F8F8F8;
$font-size:13px;
.statistics{
    margin: 0 15px;
    .line{ //行间距
      margin-top: 10px;
      background-color: $background-color;
      padding: 10px 0;
    }
    .el-input__inner{ // 修改input高度
      height: 29px !important;
      font-size: $font-size;
    }
    .el-input__icon{
      line-height: 25px;
    }
    .el-date-editor .el-range-separator{ // 至
        line-height: 22px;
        font-size: $font-size;
        padding: 0;
    }
    .el-date-editor .el-range__close-icon{ // 日历时间清空删除按钮
      line-height: 22px;
    }
    .el-date-editor .el-range__icon{ // 时间图标
      line-height: 20px;
    }
    .search_name{ //搜索类型
      color: #3A4A64 ;
      padding-left: 10px;
      font-weight: bold;
      font-size: 13.5px;
      width: 72px;
      display: inline-block;
      text-align: left;
    }
    .search_group{ // 搜索区域
      display: inline-block;
      padding-left: 10px;
      .el-radio-button:first-child .el-radio-button__inner{ // ridio第一个按钮修改样式
        border-left: 1px solid #dcdfe6;
        border-radius: 3px; 
        -webkit-box-shadow: none!important;
        box-shadow: none!important; 
      }
      .el-radio-button:last-child .el-radio-button__inner{ // 最后一个按钮
        margin-top: .5px;
        border-left: 1px solid #dcdfe6;
        border-radius: 3px; 
        -webkit-box-shadow: none;
        box-shadow: none; 
      }
      .el-radio-button__inner{
        line-height: 3px;
        border-radius: 3px;
        border-left: 1px solid #dcdfe6;
      }
      .el-radio-button{ // 单选按钮间距
        margin-right: 10px;
      }
      .el-radio-button__orig-radio:checked+.el-radio-button__inner{
        color: #409eff;
        border-color: #c6e2ff;
        background-color: #ecf5ff;
        box-shadow: 0 0 0 0 transparent;
      }
      .nav-time .el-radio-button__inner{ // 日历input 边框
        border-left: none !important;
      }
      .el-button--mini, .el-button--mini.is-round{
         padding: 0;
      }
   }
   .echart1{
     display: inline-block;
     width: 60%;
   }
   .echart2{
     display: inline-block;
     width: 40%;
   }
   #myChart1,#myChart2,#myChart3{
     padding:5px;
     background-color: $background-color;
   }
    #myChart1,#myChart2{
      padding-right: 0;
   }
   #myChart1{
     padding-bottom: 0;
   }
   .nowNum{
     background: #FF9D60;
     border-radius: 3px;
     display: inline-block;
     line-height: 28px;
     height: 27px;
     color: #FFFFFF;
     text-align: center;
     padding: 0 10px;
     min-width: 200px;
     margin-right:10px;
     margin-top: 10px; 
     margin-bottom: 5px; 
   }
   .el-table td{
    border-bottom: none;
    font-size: $font-size;
   }
   .el-table__row td{
     padding: 10px 0;
   }
   .page{
    text-align: center;
    margin-top: 30px;
    }
}

</style>


